import { mapPblCaseToOcManagedCase } from '../OcManageCases/caseReviewState';
import type { PblOcManagedCase, PblOcManagedCaseStatus } from '../OcManageCases/types';
import type { PblCase } from '@/types/pbl';

const citizenInProgressStatuses = new Set<string>([
  'pending_lawyer_timeslot',
  'pending_appointment_confirmation',
  'oc_checking',
  'meeting_scheduled',
  'in_progress',
  'pending_documents',
  'pending_completion',
]);

const citizenClosedStatuses = new Set<string>(['closed', 'appointment_cancelled']);

const citizenToBeRatedStatuses = new Set<string>(['pending_evaluation']);

const citizenToBeVerifiedStatuses = new Set<string>([
  'pending_oc_review',
  'oc_review_failed',
  'initiated',
  'matching_ready',
  'ai_matching_in_progress',
  'ai_matched',
  'manual_assignment_required',
  'lawyer_invited',
  'lawyer_accepted',
  'pending_reassignment',
  'meeting_link_pending',
  'meeing_link_pending',
]);

const citizenDetailAllowedVerificationStatuses = new Set<string>([
  'initiated',
  'matching_ready',
  'ai_matching_in_progress',
  'ai_matched',
  'manual_assignment_required',
  'lawyer_invited',
  'pending_lawyer_response',
  'lawyer_accepted',
  'pending_reassignment',
  'oc_review_failed',
]);

const getCitizenCaseListStatus = (status: string): PblOcManagedCaseStatus | null => {
  if (citizenInProgressStatuses.has(status)) return 'in_progress';
  if (citizenToBeRatedStatuses.has(status)) return 'to_be_rated';
  if (status === 'case_cancelled') return 'case_cancelled';
  if (citizenClosedStatuses.has(status)) return 'case_closed';
  if (citizenToBeVerifiedStatuses.has(status)) return 'to_be_confirmed';

  return null;
};

export const isCitizenManagedCaseDetailAccessible = (item: PblOcManagedCase) =>
  item.status === 'in_progress' ||
  item.status === 'to_be_rated' ||
  item.status === 'case_closed' ||
  item.status === 'case_cancelled' ||
  citizenDetailAllowedVerificationStatuses.has(item.backendStatus || '');

export const mapPblCaseToCitizenManagedCase = (item: PblCase): PblOcManagedCase | null => {
  const status = getCitizenCaseListStatus(item.status);
  if (!status) return null;

  return {
    ...mapPblCaseToOcManagedCase(item),
    status,
  };
};

export const mapPblCasesToCitizenManagedCases = (cases: PblCase[]) =>
  cases.reduce<PblOcManagedCase[]>((rows, item) => {
    const row = mapPblCaseToCitizenManagedCase(item);
    if (row) rows.push(row);

    return rows;
  }, []);
